import { render } from "./DetailOrdersCard.vue?vue&type=template&id=8bf87afe&scoped=true"
import script from "./DetailOrdersCard.vue?vue&type=script&lang=js"
export * from "./DetailOrdersCard.vue?vue&type=script&lang=js"

import "./DetailOrdersCard.vue?vue&type=style&index=0&id=8bf87afe&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8bf87afe"]])

export default __exports__